<div class="form-details-container container-fluid">
  <div class="details-header">
    <button (click)="goBack()" class="btn btn-secondary">← Back to List</button>
    <h2>{{ template?.name || 'Loading...' }}</h2>
    <div class="header-actions">
      <span *ngIf="template" class="version-badge">Version {{ template.version }}</span>
      <span *ngIf="template" [class]="'status-badge status-' + template.status">
        {{ template.status | titlecase }}
      </span>
    </div>
  </div>

  <div *ngIf="loading" class="loading">
    Loading form...
  </div>

  <div *ngIf="!loading && template" class="details-content">
    <!-- Form Info Section -->
    <div class="info-section">
      <h3>Form Information</h3>
      <div class="info-grid">
        <div class="info-item">
          <label>Form ID</label>
          <p class="monospace">{{ template.id }}</p>
        </div>
        <div class="info-item">
          <label>Status</label>
          <p>{{ template.status | titlecase }}</p>
        </div>
        <div class="info-item">
          <label>Version</label>
          <p>{{ template.version }}</p>
        </div>
        <div class="info-item">
          <label>Created</label>
          <p>{{ template.createdAt | date: 'medium' }}</p>
        </div>
        <div class="info-item">
          <label>Updated</label>
          <p>{{ template.updatedAt | date: 'medium' }}</p>
        </div>
        <div class="info-item">
          <label>Total Fields</label>
          <p>{{ getTotalFields() }}</p>
        </div>
        <div class="info-item">
          <label>Total Tabs</label>
          <p>{{ template.tabs.length }}</p>
        </div>
      </div>
    </div>

    <!-- Tabs and Fields Section -->
    <div class="tabs-section">
      <h3>Form Structure</h3>
      <div *ngFor="let tab of template.tabs; let i = index" class="tab-details">
        <div class="tab-header-detail">
          <h4>{{ tab.title }} <span class="field-count">({{ tab.fields.length }} fields)</span></h4>
        </div>
        <div class="fields-list">
          <div *ngFor="let field of tab.fields" class="field-preview">
            <div class="field-info">
              <strong>{{ field.label }}</strong>
              <span class="field-type">{{ field.type }}</span>
              <span *ngIf="field.required" class="required-badge">Required</span>
            </div>
            <div class="field-meta">
              <small *ngIf="field.helpText">{{ field.helpText }}</small>
              <small *ngIf="field.pattern" class="pattern">Pattern: {{ field.pattern }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Links Section -->
    <div class="links-section">
      <h3>Form Links</h3>
      <div *ngIf="formLinks.length === 0" class="empty-links">
        <p>This form is not linked to any tasks or projects yet.</p>
      </div>
      <div *ngIf="formLinks.length > 0" class="links-list">
        <div *ngFor="let link of formLinks" class="link-item">
          <span class="link-type">{{ link.linkType | titlecase }}</span>
          <span class="link-id">{{ link.linkedId }}</span>
          <button (click)="removeLink(link.id)" class="btn btn-sm btn-danger">Remove</button>
        </div>
      </div>
    </div>

    <!-- Actions Section -->
    <div class="actions-section">
      <button (click)="editForm()" class="btn btn-primary">✎ Edit Form</button>
      <button *ngIf="template.status === 'draft'" (click)="publishForm()" [disabled]="isPublishing"
        class="btn btn-success">
        {{ isPublishing ? '⏳ Publishing...' : '📤 Publish' }}
      </button>
      <button *ngIf="template.status === 'published' || template.status === 'draft'" (click)="archiveForm()"
        [disabled]="isArchiving" class="btn btn-warning">
        {{ isArchiving ? '⏳ Archiving...' : '🗑 Archive' }}
      </button>
      <button (click)="duplicateForm()" class="btn btn-secondary">
        📋 Duplicate
      </button>
    </div>

    <!-- Success/Error Alertbox -->
    <app-alertbox *ngIf="showsuccessarchive" [alerticon]="'check_circle'" [alerttype]="'success'"
      [alerttext]="'forms.successarchive' | trans">
    </app-alertbox>

    <app-alertbox *ngIf="showerrorarchive" [alerticon]="'error'" [alerttype]="'error'" [alerttext]="errorMessage">
    </app-alertbox>

    <!-- Confirmation Alertbox -->
    <app-alertbox *ngIf="showconfirmarchive" [alerttype]="'confirm'" [alerticon]="'help'"
      [alerttext]="'forms.confirmarchive.title' | trans" [confirmmessage]="'forms.confirmarchive.message' | trans"
      [confirmButtonText]="'forms.archive' | trans" [cancelButtonText]="'forms.cancel' | trans"
      (confirmed)="onArchiveConfirmed()" (cancelled)="onArchiveCancelled()">
    </app-alertbox>

    <div *ngIf="errorMessage && !showerrorarchive" class="error-alert">
      {{ errorMessage }}
    </div>
    <div *ngIf="successMessage && !showsuccessarchive" class="success-alert">
      {{ successMessage }}
    </div>
  </div>
</div>